<script>
import projects from '@/data/projects';
import ProjectSingle from "@/components/projects/ProjectSingle.vue";

export default {
  name: 'HomeProjectsGrid',
  components: {ProjectSingle},
  data() {
    return {
      homeProjects: projects.slice(1, 4)
    }
  }
}
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10">
    <div v-for="project in homeProjects"
         :key="project.id"
         class="transform transition duration-300 hover:-translate-y-2 rounded-xl shadow-lg hover:shadow-xl cursor-pointer mb-10 sm:mb-0 bg-secondary-light dark:bg-ternary-dark">
      <ProjectSingle :project="project" />
    </div>
  </div>
</template>
